/* ==========================================================================
   SOGANN — Shopify theme scripts
   Vanilla JS. Cart is wired to Shopify's AJAX Cart API (/cart/*.js).
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var theme = window.theme || {};
  var routes = theme.routes || {};
  var CART_ADD = (routes.cart_add_url || '/cart/add') + '.js';
  var CART_CHANGE = (routes.cart_change_url || '/cart/change') + '.js';
  var CART_URL = (routes.cart_url || '/cart') + '.js';

  /* ---------- Money formatting (mirrors shop.money_format) ---------- */
  function formatMoney(cents, format) {
    var fmt = format || theme.moneyFormat || '₹{{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return num(cents, 2);
        case 'amount_no_decimals': return num(cents, 0);
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', '');
        default: return num(cents, 2);
      }
    });
  }

  /* ---------- Broken image fallback ---------- */
  document.addEventListener('error', function (e) {
    var el = e.target;
    if (el && el.tagName === 'IMG' && !el.dataset.fallbackDone) {
      el.dataset.fallbackDone = '1';
      el.classList.add('img-fallback');
      el.removeAttribute('src');
      el.removeAttribute('srcset');
    }
  }, true);

  /* ---------- Toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Announcement rotator ---------- */
  (function () {
    var items = $$('.announce-item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4200);
  })();

  /* ---------- Overlay helpers ---------- */
  var scrim = $('#scrim');
  function closeAll() {
    $$('.is-open').forEach(function (el) {
      if (el.matches('.mnav,.cart-drawer,.search-panel,.filters')) el.classList.remove('is-open');
    });
    if (scrim) scrim.classList.remove('is-on');
    document.body.style.overflow = '';
  }
  function openPanel(el) {
    if (!el) return;
    closeAll();
    el.classList.add('is-open');
    if (scrim) scrim.classList.add('is-on');
    document.body.style.overflow = 'hidden';
  }
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeAll(); }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#mnavOpen')) openPanel($('#mnav'));
    if (e.target.closest('[data-open-search]')) {
      var p = $('#searchPanel'); openPanel(p);
      var inp = p && $('input', p);
      if (inp) setTimeout(function () { inp.focus(); }, 320);
    }
    if (e.target.closest('#filterOpen')) openPanel($('#filters'));
    var cartBtn = e.target.closest('[data-open-cart]');
    if (cartBtn && $('#cartDrawer')) { e.preventDefault(); openPanel($('#cartDrawer')); refreshCart(); }
  });

  /* ---------- Generic disclosure (mobile nav, accordions, filters) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-toggle]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    if (!panel) return;
    if (panel.hasAttribute('hidden') || !panel.classList.contains('mnav-panel')) {
      if (open) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); }
    }
    panel.classList.toggle('is-open', !open);
  });

  /* ---------- Shopify Cart ---------- */
  function getCart() { return fetch(CART_URL, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function cartLineMarkup(item, wide) {
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    var variant = (item.product_has_only_default_variant ? '' : item.variant_title) || '';
    return '' +
      '<div class="' + (wide ? 'cart-row' : 'cart-line') + '">' +
        '<a href="' + item.url + '"><img src="' + img + '" alt="' + (item.product_title || '') + '"></a>' +
        '<div class="' + (wide ? 'cr-main' : '') + '">' +
          '<div class="cl-top">' +
            '<div>' +
              '<a class="' + (wide ? 'cr-name' : 'cl-name') + '" href="' + item.url + '">' + item.product_title + '</a>' +
              (variant ? '<div class="cl-var">' + variant + '</div>' : '') +
            '</div>' +
            '<span class="cl-price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<div class="' + (wide ? 'cr-foot' : 'cl-bottom') + '">' +
            '<span class="qty">' +
              '<button type="button" data-qty-key="' + item.key + '" data-qty-to="' + (item.quantity - 1) + '" aria-label="Reduce quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-key="' + item.key + '" data-qty-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<button type="button" class="cl-remove" data-qty-key="' + item.key + '" data-qty-to="0">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    var count = cart.item_count;
    var emptyHtml = '<div class="cart-empty"><p>Your bag is empty.</p><a class="btn btn--ghost btn--sm" href="' + (routes.all_products_collection_url || '/collections/all') + '">Shop all</a></div>';

    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count ? '' : 'none';
    });

    var body = $('#cartBody');
    if (body) body.innerHTML = count ? cart.items.map(function (l) { return cartLineMarkup(l, false); }).join('') : emptyHtml;

    var pageList = $('#cartPageList');
    if (pageList) pageList.innerHTML = count ? cart.items.map(function (l) { return cartLineMarkup(l, true); }).join('') : emptyHtml;

    $$('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    $$('[data-checkout]').forEach(function (b) { b.disabled = count === 0; });
    $$('.cart-page').forEach(function (el) { el.classList.toggle('is-empty', count === 0); });
  }

  function refreshCart() { return getCart().then(renderCart); }

  function changeLine(key, qty) {
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addVariant(id, qty, cb) {
    fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.status) { toast(data.description || 'Could not add to bag'); return; }
      toast((data.product_title || 'Item') + ' added to bag');
      refreshCart();
      if (cb) cb();
    }).catch(function () { toast('Could not add to bag'); });
  }

  /* Add-to-cart buttons carrying a variant id (product cards, PDP) */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-add-variant');
      var qtyField = add.form && add.form.querySelector('[name="quantity"]');
      var qty = qtyField ? Number(qtyField.value) : Number(add.getAttribute('data-qty') || 1);
      if (!id) return;
      add.classList.add('is-loading');
      addVariant(id, qty, function () {
        add.classList.remove('is-loading');
        if (add.hasAttribute('data-open-after') && $('#cartDrawer')) openPanel($('#cartDrawer'));
      });
      return;
    }
    var q = e.target.closest('[data-qty-key]');
    if (q) { e.preventDefault(); changeLine(q.getAttribute('data-qty-key'), Number(q.getAttribute('data-qty-to'))); }
  });

  /* ---------- Product card image swap on swatch hover ---------- */
  $$('.pcard').forEach(function (card) {
    var img = $('.p-main', card);
    if (!img) return;
    var original = img.getAttribute('src');
    $$('.sw', card).forEach(function (sw) {
      sw.addEventListener('mouseenter', function () { if (sw.dataset.img) img.src = sw.dataset.img; });
      sw.addEventListener('click', function () {
        $$('.sw', card).forEach(function (s) { s.classList.remove('is-on'); });
        sw.classList.add('is-on');
        original = sw.dataset.img || original;
      });
    });
    card.addEventListener('mouseleave', function () { img.src = original; });
  });

  /* ---------- Gallery (thumbnail -> main image) ---------- */
  $$('[data-gallery]').forEach(function (root) {
    var main = $('[data-gallery-main]', root);
    if (!main) return;
    $$('[data-gallery-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-gallery-thumb]', root).forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        if (b.dataset.img) main.src = b.dataset.img;
        if (b.dataset.srcset) main.srcset = b.dataset.srcset;
      });
    });
  });

  /* ---------- Product form: variant selection ---------- */
  $$('form.pdp-form').forEach(function (form) {
    var root = form.closest('[data-product]') || document;
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idField = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-add-variant]');
    var priceNow = $('[data-price-now]', root);
    var priceWas = $('[data-price-was]', root);
    var priceOff = $('[data-price-off]', root);
    var main = $('[data-gallery-main]', root);

    function currentOptions() {
      var opts = [];
      $$('[data-option-index]', form).forEach(function (input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (input.checked) opts[Number(input.getAttribute('data-option-index'))] = input.value;
        } else {
          opts[Number(input.getAttribute('data-option-index'))] = input.value;
        }
      });
      return opts;
    }
    var optionInputs = $$('[data-option-index]', form);
    function findVariant(opts) {
      // Products with no options (single/default variant) have no option inputs.
      if (!optionInputs.length || !opts.length) {
        return variants.filter(function (v) { return v.available; })[0] || variants[0];
      }
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function update() {
      var v = findVariant(currentOptions());
      if (!v) {
        if (addBtn) { addBtn.setAttribute('disabled', ''); addBtn.textContent = addBtn.getAttribute('data-unavailable') || 'Unavailable'; }
        return;
      }
      if (idField) idField.value = v.id;
      if (addBtn) {
        addBtn.setAttribute('data-add-variant', v.id);
        if (v.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = addBtn.getAttribute('data-default') || 'Add to bag'; }
        else { addBtn.setAttribute('disabled', ''); addBtn.textContent = addBtn.getAttribute('data-soldout') || 'Sold out'; }
      }
      if (priceNow) priceNow.innerHTML = formatMoney(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.innerHTML = formatMoney(v.compare_at_price);
          priceWas.style.display = '';
          if (priceOff) { priceOff.style.display = ''; priceOff.textContent = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '% off'; }
        } else {
          priceWas.style.display = 'none';
          if (priceOff) priceOff.style.display = 'none';
        }
      }
      if (v.featured_image && main) { main.src = v.featured_image.src; main.removeAttribute('srcset'); }
      var label = $('[data-variant-label]', root);
      if (label) label.textContent = v.title;
    }
    $$('[data-option-index]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.type === 'radio') {
          var lbl = form.querySelector('label[for="' + input.id + '"]');
          $$('[data-option-index="' + input.getAttribute('data-option-index') + '"]', form).forEach(function (r) {
            var l = form.querySelector('label[for="' + r.id + '"]');
            if (l) l.classList.toggle('is-on', r.checked);
          });
        }
        update();
      });
    });
    update();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var wrap = b.closest('.qty');
    var field = wrap && wrap.querySelector('input[name="quantity"]');
    if (!field) return;
    var v = Math.max(1, (Number(field.value) || 1) + Number(b.getAttribute('data-qty-step')));
    field.value = v;
  });

  /* ---------- Scroll reveal ---------- */
  (function () {
    var els = $$('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach(function (root) {
    var track = $('[data-slider-track]', root);
    var slides = $$('.hs-slide', root);
    var dots = $$('[data-slider-dot]', root);
    var n = slides.length;
    if (!track || n < 1) return;
    var i = 0, timer = null;
    var interval = Number(root.getAttribute('data-autoplay')) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
    }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }
    function start() { if (reduce || n < 2 || !interval) return; stop(); timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var bn = $('[data-slider-next]', root), bp = $('[data-slider-prev]', root);
    if (bn) bn.addEventListener('click', function () { next(); start(); });
    if (bp) bp.addEventListener('click', function () { prev(); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slider-dot'), 10) || 0); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { (dx < 0 ? next : prev)(); start(); }
      x0 = null;
    });
    go(0); start();
  });

  /* ---------- Product image click-to-zoom (lightbox) ---------- */
  (function () {
    var main = $('#pdp [data-gallery-main]') || $('.pdp-main [data-gallery-main]');
    if (!main) return;
    main.style.cursor = 'zoom-in';
    function open() {
      var ov = document.createElement('div');
      ov.className = 'img-zoom';
      var img = document.createElement('img');
      img.src = main.currentSrc || main.src;
      img.alt = main.alt || '';
      ov.appendChild(img);
      document.body.appendChild(ov);
      document.body.style.overflow = 'hidden';
      ov.addEventListener('click', close);
    }
    function close() {
      var z = $('.img-zoom');
      if (z) { z.parentNode.removeChild(z); document.body.style.overflow = ''; }
    }
    main.addEventListener('click', open);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  /* Init cart count on load */
  if ($('[data-cart-count]') || $('#cartBody') || $('#cartPageList')) refreshCart();
})();